/* =============================================
   SCORPIUS THEME — v3 JS
   ============================================= */

(function(){
  'use strict';

  /* -------------------------------------------------
     THEME EDITOR DETECTION
     When the Shopify theme editor is active, we need to:
       1. Skip the "reveal on scroll" animation entirely so sections never appear blank.
       2. Re-initialise every interactive widget when a section is re-rendered.
  ------------------------------------------------- */
  var IN_EDITOR = !!(window.Shopify && window.Shopify.designMode);
  if (IN_EDITOR) {
    document.documentElement.classList.add('shopify-design-mode');
  }

  function show(el){ el.classList.add('visible'); }

  /* -------------------------------------------------
     NAV SCROLL STATE
  ------------------------------------------------- */
  var nav = document.querySelector('.nav');
  function navScroll(){ if(nav) nav.classList.toggle('nav--scrolled', window.scrollY > 12); }
  window.addEventListener('scroll', navScroll, { passive: true });
  navScroll();

  /* -------------------------------------------------
     REVEAL ON SCROLL
  ------------------------------------------------- */
  var io = null;
  function initReveals(scope){
    scope = scope || document;
    var els = scope.querySelectorAll('.reveal');
    if (IN_EDITOR) {
      // In the theme editor we never hide anything.
      els.forEach(show);
      return;
    }
    if ('IntersectionObserver' in window) {
      if (!io) {
        io = new IntersectionObserver(function(entries){
          entries.forEach(function(e){
            if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
          });
        }, { threshold: 0.07, rootMargin: '0px 0px -40px 0px' });
      }
      els.forEach(function(el){ if(!el.classList.contains('visible')) io.observe(el); });
    } else {
      els.forEach(show);
    }
  }

  /* -------------------------------------------------
     DROPDOWN NAV
  ------------------------------------------------- */
  function initDropdowns(scope){
    (scope || document).querySelectorAll('.nav__item--has-drop').forEach(function(item){
      if (item.dataset.bound) return;
      item.dataset.bound = '1';
      var btn = item.querySelector('.nav__item-btn');
      var open = false;
      var closeTimer = null;
      var enter = function(){ if(closeTimer){ clearTimeout(closeTimer); closeTimer = null; } open = true; item.classList.add('open'); if(btn) btn.setAttribute('aria-expanded','true'); };
      var doClose = function(){ open = false; item.classList.remove('open'); if(btn) btn.setAttribute('aria-expanded','false'); };
      var leave = function(){ if(closeTimer) clearTimeout(closeTimer); closeTimer = setTimeout(doClose, 180); };
      item.addEventListener('mouseenter', enter);
      item.addEventListener('mouseleave', leave);
      if(btn) btn.addEventListener('click', function(e){ e.preventDefault(); open ? doClose() : enter(); });
    });
  }

  /* -------------------------------------------------
     MOBILE DRAWER
  ------------------------------------------------- */
  var burger, drawer, overlay, closeBtn;
  function bindMobileDrawer(){
    burger = document.getElementById('nav-burger');
    drawer = document.getElementById('nav-mobile');
    overlay = document.getElementById('nav-overlay');
    closeBtn = document.getElementById('nav-mobile-close');
    if (burger && !burger.dataset.bound) { burger.dataset.bound = '1'; burger.addEventListener('click', openDrawer); }
    if (closeBtn && !closeBtn.dataset.bound) { closeBtn.dataset.bound = '1'; closeBtn.addEventListener('click', closeDrawer); }
    if (overlay && !overlay.dataset.bound) {
      overlay.dataset.bound = '1';
      overlay.addEventListener('click', function(){ closeDrawer(); closeCartDrawer(); closeSearch(); });
    }
  }
  function openDrawer(){ if(!drawer) return; drawer.classList.add('open'); overlay && overlay.classList.add('open'); document.body.style.overflow = 'hidden'; if(burger) burger.setAttribute('aria-expanded','true'); }
  function closeDrawer(){ if(!drawer) return; drawer.classList.remove('open'); overlay && overlay.classList.remove('open'); document.body.style.overflow = ''; if(burger) burger.setAttribute('aria-expanded','false'); }

  /* -------------------------------------------------
     SEARCH OVERLAY
  ------------------------------------------------- */
  var searchOverlay, searchInput, searchResults;
  function bindSearch(){
    var searchBtn = document.getElementById('search-trigger');
    var searchClose = document.getElementById('search-close');
    searchOverlay = document.getElementById('search-overlay');
    searchInput = document.getElementById('search-input');
    searchResults = document.getElementById('search-results');
    if (searchBtn && !searchBtn.dataset.bound) { searchBtn.dataset.bound = '1'; searchBtn.addEventListener('click', openSearch); }
    if (searchClose && !searchClose.dataset.bound) { searchClose.dataset.bound = '1'; searchClose.addEventListener('click', closeSearch); }
    if (searchInput && !searchInput.dataset.bound) {
      searchInput.dataset.bound = '1';
      var t = null;
      searchInput.addEventListener('input', function(){
        var q = this.value.trim();
        clearTimeout(t);
        if (!q) { if(searchResults) searchResults.innerHTML = ''; return; }
        t = setTimeout(function(){
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
            .then(function(r){ return r.json(); })
            .then(function(data){
              if (!searchResults) return;
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              if (!products.length) { searchResults.innerHTML = '<p style="padding:16px;color:var(--silver);font-size:0.88rem">No results for "' + q + '"</p>'; return; }
              searchResults.innerHTML = products.map(function(p){
                return '<a href="' + p.url + '" class="search-result"><div class="search-result__img">' + (p.featured_image ? '<img src="' + p.featured_image.url + '" alt="">' : '') + '</div><div><div class="search-result__title">' + p.title + '</div><div class="search-result__price">' + p.price + '</div></div></a>';
              }).join('');
            }).catch(function(){});
        }, 220);
      });
    }
  }
  function openSearch(){ if(!searchOverlay) return; searchOverlay.classList.add('open'); overlay && overlay.classList.add('open'); document.body.style.overflow = 'hidden'; setTimeout(function(){ if(searchInput) searchInput.focus(); }, 200); }
  function closeSearch(){ if(!searchOverlay) return; searchOverlay.classList.remove('open'); overlay && overlay.classList.remove('open'); document.body.style.overflow = ''; }

  /* -------------------------------------------------
     CART DRAWER
  ------------------------------------------------- */
  var cartDrawer;
  function bindCart(){
    cartDrawer = document.getElementById('cart-drawer');
    var cartTrigger = document.getElementById('cart-trigger');
    var cartClose = document.getElementById('cart-drawer-close');
    if (cartTrigger && !cartTrigger.dataset.bound) { cartTrigger.dataset.bound = '1'; cartTrigger.addEventListener('click', openCartDrawer); }
    if (cartClose && !cartClose.dataset.bound) { cartClose.dataset.bound = '1'; cartClose.addEventListener('click', closeCartDrawer); }
  }
  function openCartDrawer(e){ if(e) e.preventDefault(); if (!cartDrawer) return; cartDrawer.classList.add('open'); overlay && overlay.classList.add('open'); document.body.style.overflow = 'hidden'; refreshCartDrawer(); }
  function closeCartDrawer(){ if(!cartDrawer) return; cartDrawer.classList.remove('open'); overlay && overlay.classList.remove('open'); document.body.style.overflow = ''; }
  function refreshCartDrawer(){
    var body = document.getElementById('cart-drawer-body');
    var foot = document.getElementById('cart-drawer-foot');
    if (!body) return;
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      updateCartBadge(cart.item_count);
      if (cart.item_count === 0){
        body.innerHTML = '<div class="cart-empty-msg"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--ink">Continue shopping</a></div>';
        if (foot) foot.style.display = 'none';
        return;
      }
      if (foot) foot.style.display = '';
      body.innerHTML = cart.items.map(function(it){
        return '<div class="drawer-item" data-key="' + it.key + '">' +
          '<div class="drawer-item__img">' + (it.image ? '<img src="' + it.image + '" alt="">' : '') + '</div>' +
          '<div><div class="drawer-item__title">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="drawer-item__variant">' + it.variant_title + '</div>' : '') +
          '<div class="drawer-item__row"><div class="drawer-item__qty"><button data-act="dec">-</button><span>' + it.quantity + '</span><button data-act="inc">+</button></div>' +
          '<div class="drawer-item__price">' + formatMoney(it.final_line_price) + '</div></div>' +
          '<button class="drawer-item__remove" data-act="rm">Remove</button></div></div>';
      }).join('');
      var totalEl = document.getElementById('cart-drawer-total');
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
      body.querySelectorAll('.drawer-item').forEach(function(row){
        var key = row.dataset.key;
        row.querySelectorAll('[data-act]').forEach(function(b){
          b.addEventListener('click', function(){
            var act = b.dataset.act;
            var qty = parseInt(row.querySelector('span').textContent, 10);
            if (act === 'inc') qty++;
            else if (act === 'dec') qty = Math.max(0, qty - 1);
            else if (act === 'rm') qty = 0;
            fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id: key, quantity: qty }) }).then(refreshCartDrawer);
          });
        });
      });
    });
  }
  window.openCartDrawer = openCartDrawer;
  window.refreshCartDrawer = refreshCartDrawer;

  function updateCartBadge(count){
    document.querySelectorAll('.cart-count-badge').forEach(function(el){ el.textContent = count; el.style.display = count > 0 ? '' : 'none'; });
  }
  function formatMoney(cents){ return '£' + (cents / 100).toFixed(2); }

  /* AJAX add-to-cart */
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[data-ajax-atc]');
    if (!form) return;
    if (IN_EDITOR) return; // don't interfere with editor previews
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', { method:'POST', headers:{'X-Requested-With':'XMLHttpRequest'}, body: new FormData(form) })
      .then(function(r){ return r.json(); })
      .then(function(){
        if (btn) { btn.textContent = 'Added ✓'; setTimeout(function(){ btn.textContent = originalText; btn.disabled = false; }, 1400); }
        openCartDrawer();
      })
      .catch(function(){ if (btn) { btn.textContent = originalText; btn.disabled = false; } });
  });

  // Initial cart badge
  if (!IN_EDITOR) {
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){ updateCartBadge(c.item_count); }).catch(function(){});
  }

  /* -------------------------------------------------
     ANNOUNCEMENT BAR CAROUSEL
  ------------------------------------------------- */
  function initAnnouncementBar(scope){
    (scope || document).querySelectorAll('.announcement-bar').forEach(function(bar){
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';
      var msgs = bar.querySelectorAll('.announcement-bar__msg');
      if (msgs.length === 0) return;
      msgs.forEach(function(m){ m.classList.remove('active'); });
      msgs[0].classList.add('active');
      if (msgs.length === 1) return;
      var current = 0;
      var speed = parseInt(bar.dataset.speed || '5', 10) * 1000;
      var auto = bar.dataset.autoplay === 'true' && !IN_EDITOR;
      function showMsg(n){
        msgs.forEach(function(m){ m.classList.remove('active'); });
        current = (n + msgs.length) % msgs.length;
        msgs[current].classList.add('active');
      }
      if (auto) {
        var timer = setInterval(function(){ showMsg(current + 1); }, speed);
        bar._timer = timer;
      }
      var prev = bar.querySelector('.announcement-bar__prev');
      var next = bar.querySelector('.announcement-bar__next');
      if (prev) prev.addEventListener('click', function(){ showMsg(current - 1); });
      if (next) next.addEventListener('click', function(){ showMsg(current + 1); });
    });
  }

  /* -------------------------------------------------
     FAQ
  ------------------------------------------------- */
  function initFAQ(scope){
    (scope || document).querySelectorAll('.faq-item').forEach(function(item){
      if (item.dataset.bound) return;
      item.dataset.bound = '1';
      var q = item.querySelector('.faq-q');
      if (q) q.addEventListener('click', function(){ item.classList.toggle('open'); });
    });
  }

  /* -------------------------------------------------
     TABS (PDP / Calculator)
  ------------------------------------------------- */
  window.showTab = function(id, btn){
    var container = btn.closest('.pdp-tabs, .tab-container, body') || document;
    container.querySelectorAll('.tab-panel').forEach(function(p){ p.classList.remove('active'); });
    container.querySelectorAll('.tab-btn').forEach(function(b){ b.classList.remove('active'); });
    var panel = container.querySelector('#panel-' + id);
    if (panel) panel.classList.add('active');
    btn.classList.add('active');
  };

  /* -------------------------------------------------
     PDP variant pills
  ------------------------------------------------- */
  window.selectPill = function(btn){
    var group = btn.closest('.option-pills');
    if (!group) return;
    group.querySelectorAll('.option-pill').forEach(function(p){ p.classList.remove('active'); });
    btn.classList.add('active');
  };

  /* -------------------------------------------------
     PDP qty stepper
  ------------------------------------------------- */
  function initQtyStepper(scope){
    (scope || document).querySelectorAll('.pdp__qty').forEach(function(wrap){
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var input = wrap.querySelector('.pdp__qty-input');
      wrap.querySelectorAll('.pdp__qty-btn').forEach(function(b){
        b.addEventListener('click', function(){
          var v = parseInt(input.value, 10) || 1;
          if (b.dataset.dir === 'up') input.value = v + 1;
          else input.value = Math.max(1, v - 1);
        });
      });
    });
  }

  /* -------------------------------------------------
     STICKY ATC
  ------------------------------------------------- */
  function initStickyAtc(){
    var stickyAtc = document.getElementById('sticky-atc');
    var pdpBtns = document.querySelector('.pdp__btns');
    if (!stickyAtc || !pdpBtns) return;
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        stickyAtc.classList.toggle('visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(pdpBtns);
  }

  /* -------------------------------------------------
     RECENTLY VIEWED (localStorage)
  ------------------------------------------------- */
  function trackRecentlyViewed(){
    if (!document.body.classList.contains('template-product')) return;
    var handle = document.body.dataset.productHandle;
    if (!handle) return;
    try {
      var list = JSON.parse(localStorage.getItem('scorpius_recent') || '[]');
      list = list.filter(function(h){ return h !== handle; });
      list.unshift(handle);
      list = list.slice(0, 6);
      localStorage.setItem('scorpius_recent', JSON.stringify(list));
    } catch(e){}
  }
  function renderRecentlyViewed(){
    var container = document.getElementById('recently-viewed');
    if (!container) return;
    try {
      var list = JSON.parse(localStorage.getItem('scorpius_recent') || '[]');
      var current = document.body.dataset.productHandle;
      list = list.filter(function(h){ return h !== current; }).slice(0, 4);
      if (!list.length) { container.style.display = 'none'; return; }
      Promise.all(list.map(function(h){
        return fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
      })).then(function(items){
        items = items.filter(Boolean);
        if (!items.length) { container.style.display = 'none'; return; }
        var grid = container.querySelector('.shop-grid');
        if (!grid) return;
        grid.innerHTML = items.map(function(p){
          return '<a href="' + p.url + '" class="device-card"><div class="device-card__img">' + (p.featured_image ? '<img src="' + p.featured_image + '" alt="' + p.title + '">' : '<div class="device-card__phone"></div>') + '</div><div class="device-card__info"><div class="device-card__name">' + p.title + '</div><div class="device-card__sub">' + (p.vendor || '') + '</div><div class="device-card__price-row"><span class="device-card__price">' + formatMoney(p.price) + '</span></div></div></a>';
        }).join('');
      });
    } catch(e){}
  }

  /* -------------------------------------------------
     TESTIMONIAL SLIDER
  ------------------------------------------------- */
  function initTestimonialSlider(scope){
    (scope || document).querySelectorAll('.testimonial-slider').forEach(function(slider){
      if (slider.dataset.bound) return;
      slider.dataset.bound = '1';
      var track = slider.querySelector('.testimonial-track');
      if (!track) return;
      var prev = slider.querySelector('.testimonial-nav__prev');
      var next = slider.querySelector('.testimonial-nav__next');
      var step = function(){ var c = track.querySelector('.testimonial-card'); return c ? c.offsetWidth + 24 : 320; };
      if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  }

  /* -------------------------------------------------
     VIDEO play
  ------------------------------------------------- */
  function initVideo(scope){
    (scope || document).querySelectorAll('.video-wrap').forEach(function(wrap){
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var btn = wrap.querySelector('.video-play');
      var vid = wrap.querySelector('video');
      var iframe = wrap.querySelector('iframe');
      if (!btn) return;
      btn.addEventListener('click', function(){
        btn.style.display = 'none';
        if (vid) { vid.controls = true; vid.play(); }
        else if (iframe) {
          var src = iframe.dataset.src || iframe.src;
          if (src.indexOf('autoplay') === -1) src += (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
          iframe.src = src;
        }
      });
    });
  }

  /* -------------------------------------------------
     COOKIE BANNER
  ------------------------------------------------- */
  function initCookieBanner(){
    if (IN_EDITOR) return;
    var cookie = document.getElementById('cookie-banner');
    if (!cookie) return;
    try {
      if (!localStorage.getItem('scorpius_cookies_v1')){
        setTimeout(function(){ cookie.classList.add('visible'); }, 1200);
      }
      var accept = cookie.querySelector('[data-cookie="accept"]');
      var decline = cookie.querySelector('[data-cookie="decline"]');
      function dismiss(val){ try { localStorage.setItem('scorpius_cookies_v1', val); } catch(e){} cookie.classList.remove('visible'); }
      if (accept) accept.addEventListener('click', function(){ dismiss('accepted'); });
      if (decline) decline.addEventListener('click', function(){ dismiss('declined'); });
    } catch(e){}
  }

  /* -------------------------------------------------
     BACK TO TOP
  ------------------------------------------------- */
  function initBackToTop(){
    var backTop = document.getElementById('back-to-top');
    if (!backTop || backTop.dataset.bound) return;
    backTop.dataset.bound = '1';
    function bt(){ backTop.classList.toggle('visible', window.scrollY > 600); }
    window.addEventListener('scroll', bt, { passive: true });
    backTop.addEventListener('click', function(){ window.scrollTo({ top: 0, behavior: 'smooth' }); });
    bt();
  }

  /* -------------------------------------------------
     SCROLL PROGRESS
  ------------------------------------------------- */
  function initScrollProgress(){
    var progress = document.querySelector('.scroll-progress');
    if (!progress) return;
    function update(){
      var h = document.documentElement;
      var scrolled = (h.scrollTop) / (h.scrollHeight - h.clientHeight) * 100;
      progress.style.width = scrolled + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* -------------------------------------------------
     COUNTDOWN TIMER
  ------------------------------------------------- */
  function initCountdown(scope){
    (scope || document).querySelectorAll('.countdown').forEach(function(sec){
      if (sec.dataset.bound) return;
      sec.dataset.bound = '1';
      var end = new Date(sec.dataset.end);
      if (isNaN(end.getTime())) return;
      var timer = sec.querySelector('[data-countdown]');
      var expired = sec.querySelector('.countdown__expired');
      var d = sec.querySelector('[data-d]');
      var h = sec.querySelector('[data-h]');
      var m = sec.querySelector('[data-m]');
      var s = sec.querySelector('[data-s]');
      function pad(n){ return n < 10 ? '0' + n : '' + n; }
      function tick(){
        var ms = end.getTime() - Date.now();
        if (ms <= 0) {
          if (timer) timer.style.display = 'none';
          if (expired) expired.hidden = false;
          clearInterval(sec._tick);
          return;
        }
        var dd = Math.floor(ms / 86400000);
        var hh = Math.floor((ms % 86400000) / 3600000);
        var mm = Math.floor((ms % 3600000) / 60000);
        var ss = Math.floor((ms % 60000) / 1000);
        if (d) d.textContent = pad(dd);
        if (h) h.textContent = pad(hh);
        if (m) m.textContent = pad(mm);
        if (s) s.textContent = pad(ss);
      }
      tick();
      sec._tick = setInterval(tick, 1000);
    });
  }

  /* -------------------------------------------------
     BEFORE / AFTER SLIDER
  ------------------------------------------------- */
  function initBeforeAfter(scope){
    (scope || document).querySelectorAll('[data-before-after]').forEach(function(wrap){
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      var before = wrap.querySelector('[data-ba-before]');
      var handle = wrap.querySelector('[data-ba-handle]');
      var dragging = false;
      function setPct(pct){
        pct = Math.max(0, Math.min(100, pct));
        if (before) before.style.width = pct + '%';
        if (handle) handle.style.left = pct + '%';
      }
      setPct(50);
      function update(clientX){
        var r = wrap.getBoundingClientRect();
        setPct(((clientX - r.left) / r.width) * 100);
      }
      function start(e){ dragging = true; update((e.touches ? e.touches[0] : e).clientX); }
      function move(e){ if(!dragging) return; update((e.touches ? e.touches[0] : e).clientX); }
      function end(){ dragging = false; }
      wrap.addEventListener('mousedown', start);
      wrap.addEventListener('touchstart', start, { passive: true });
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('mouseup', end);
      window.addEventListener('touchend', end);
      if (handle) handle.addEventListener('keydown', function(e){
        if (e.key === 'ArrowLeft') setPct(parseFloat(handle.style.left) - 5);
        else if (e.key === 'ArrowRight') setPct(parseFloat(handle.style.left) + 5);
      });
    });
  }

  /* -------------------------------------------------
     WISHLIST (localStorage)
  ------------------------------------------------- */
  var WL_KEY = 'scorpius_wishlist_v1';
  function getWishlist(){
    try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch(e){ return []; }
  }
  function setWishlist(list){
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch(e){}
    updateWishlistButtons();
  }
  function updateWishlistButtons(){
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
      var handle = btn.dataset.productHandle;
      var saved = list.indexOf(handle) > -1;
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      var label = btn.querySelector('.wishlist-btn__label');
      if (label) label.textContent = saved ? 'Saved' : 'Save';
    });
  }
  function initWishlist(scope){
    (scope || document).querySelectorAll('[data-wishlist-toggle]').forEach(function(btn){
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function(e){
        e.preventDefault(); e.stopPropagation();
        var handle = btn.dataset.productHandle;
        if (!handle) return;
        var list = getWishlist();
        var i = list.indexOf(handle);
        if (i > -1) list.splice(i, 1); else list.unshift(handle);
        setWishlist(list);
      });
    });
    updateWishlistButtons();
  }

  function renderWishlistPage(){
    var grid = document.getElementById('wishlist-grid');
    var empty = document.getElementById('wishlist-empty');
    if (!grid) return;
    var handles = getWishlist();
    if (!handles.length) {
      grid.style.display = 'none';
      if (empty) empty.hidden = false;
      return;
    }
    Promise.all(handles.map(function(h){
      return fetch('/products/' + h + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    })).then(function(items){
      items = items.filter(Boolean);
      if (!items.length) { grid.style.display = 'none'; if (empty) empty.hidden = false; return; }
      grid.innerHTML = items.map(function(p){
        return '<a href="' + p.url + '" class="device-card"><div class="device-card__img">' + (p.featured_image ? '<img src="' + p.featured_image + '" alt="' + p.title + '">' : '<div class="device-card__phone"></div>') + '</div><div class="device-card__info"><div class="device-card__name">' + p.title + '</div><div class="device-card__sub">' + (p.vendor || '') + '</div><div class="device-card__price-row"><span class="device-card__price">' + formatMoney(p.price) + '</span></div><span class="device-card__btn">View product</span></div></a>';
      }).join('');
    });
  }
  renderWishlistPage();

  /* -------------------------------------------------
     SOCIAL SHARE: copy-link
  ------------------------------------------------- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-copy-link]');
    if (!btn) return;
    var url = btn.dataset.copyLink;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function(){
        var orig = btn.innerHTML;
        btn.innerHTML = '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(function(){ btn.innerHTML = orig; }, 1400);
      });
    }
  });

  /* -------------------------------------------------
     MASTER INIT — called on page load AND on every
     shopify:section:load event in the theme editor
  ------------------------------------------------- */
  function initAll(scope){
    initReveals(scope);
    initDropdowns(scope);
    initAnnouncementBar(scope);
    initFAQ(scope);
    initQtyStepper(scope);
    initTestimonialSlider(scope);
    initVideo(scope);
    initCountdown(scope);
    initBeforeAfter(scope);
    initWishlist(scope);
    bindMobileDrawer();
    bindSearch();
    bindCart();
  }

  // First boot
  initAll(document);
  initStickyAtc();
  trackRecentlyViewed();
  renderRecentlyViewed();
  initCookieBanner();
  initBackToTop();
  initScrollProgress();

  /* -------------------------------------------------
     SHOPIFY EDITOR EVENTS
     Fires when merchant adds, edits, or re-orders a section.
     We re-run init on the new HTML so widgets work + nothing is hidden.
  ------------------------------------------------- */
  document.addEventListener('shopify:section:load', function(e){
    initAll(e.target);
    // Re-bind global widgets that may have been included via the new section
    initStickyAtc();
    initBackToTop();
    initScrollProgress();
  });

  document.addEventListener('shopify:section:unload', function(e){
    // Stop announcement bar timer if section is removed
    e.target.querySelectorAll('.announcement-bar').forEach(function(b){ if (b._timer) clearInterval(b._timer); });
  });

  document.addEventListener('shopify:section:select', function(e){
    // Make sure the selected section is visible
    e.target.querySelectorAll('.reveal').forEach(show);
    var sec = e.target.querySelector('.reveal') || e.target;
    if (sec) sec.classList.add('visible');
  });

  document.addEventListener('shopify:block:select', function(e){
    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* Esc key */
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){
      closeCartDrawer();
      closeSearch();
      closeDrawer();
    }
  });

})();
